<style lang="scss">
.email input {
    width: 100%;
}
</style>

<template>
<div id="account">
    <h1 class="title">account</h1>
    <div v-cloak>
        <div class="four columns email">
            <div>
                <label>name</label>
                <input type="text" v-model="user.name" disabled title="sorry, this ain't jackbox, you're stuck with your real name :)" />
            </div>
            <div>
                <label>email</label>
                <input type="text" v-model="email" />
                <div class="button-group">
                    <button @click="updateUser" :disabled="!isValidEmail">save</button>
                    <button @click="reset">reset</button>
                </div>
            </div>
        </div>

        <div class="seven columns offset-by-one">
            <label>password</label>
            <template v-if="show.pass_input">
                <div key="password">
                    <input type="password" v-model="password" />
                    <span v-if="!isValidPassword" class="tooltip" style="margin-left: 15px;">
                        Invalid Password
                        <span class="tooltiptext">
                            <ul>
                                <li>8-20 characters</li>
                                <li>1 letter</li>
                                <li>1 number</li>
                                <li>1 special character</li>
                            </ul>
                        </span>
                    </span>
                </div>
                <label>repeat password</label>
                <div key="repeat">
                    <input type="password" v-model="repeat_password" />
                    <span v-if="repeat_password.length > 8 && !isValidRepeat" style="margin-left: 15px;">Passwords do not match</span>
                </div>
                <div class="button-group">
                    <button @click="updatePassword" :disabled="!isValidPassword || !isValidRepeat">save</button>
                    <button @click="cancel">cancel</button>
                </div>
            </template>
            <template v-else>
                <button @click="show.pass_input = true">change password</button>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import _ from 'lodash';
import { auth } from '../core/auth.js';
export default {
    name: 'Account',
    data: function() {
        return {
            myAuth: auth.session,
            user: {},
            email: '',
            password: '',
            repeat_password: '',
            show: { pass_input: false, pass_text: false, },
        };
    },
    computed: {
        isValidEmail: function() {
            return this.user.email !== this.email && (/\S+@\S+/).test(this.email);
        },
        isValidPassword: function() {
            // return (/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*\]:;',?/*~$^+=<>]).{8,20}$/).test(this.password);
            return (/^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*\]:;',?/*~$^+=<>]).{8,20}$/).test(this.password);
        },
        isValidRepeat: function() {
            return this.password === this.repeat_password;
        },
    },
    created: function() {
        this.displayPassword();
        this.user = _.cloneDeep(this.myAuth.user);
        this.reset();
    },
    methods: {
        reset: function() {
            this.email = this.user.email;
        },
        cancel: function() {
            this.show.pass_input = false;
            this.password = '';
            this.repeat_password = '';
        },
        displayPassword: function() {
            return this.show.pass_text ? 'text' : 'password';
        },
        updateUser: async function() {
            let res = await fetch(`/api/graphql`, {
                method: 'POST',
                headers: {},
                body: JSON.stringify({
                    query: `mutation($id: ID!, $data: UserInput!) {
                        updateUser(id: $id, data: $data) {
                            _id
                            name
                            email
                            role
                        }
                    }`,
                    variables: {
                        id: this.user._id,
                        data: {
                            name: this.user.name,
                            email: this.email,
                            role: this.user.role,
                        },
                    },
                }),
                credentials: 'same-origin',
            });
            res = await res.json();
            if (res.errors) {
                // console.log(res.errors);
                return;
            }
            console.log('user updated');
            this.user = res.updateUser;
        },
        updatePassword: async function() {
            let res = await fetch(`/api/graphql`, {
                method: 'POST',
                headers: {},
                body: JSON.stringify({
                    query: `mutation($data: UpdatePasswordInput!) {
                        updatePassword(data: $data){
                            _id
                        }
                    }`,
                    variables: {
                        data: {
                            id: this.user._id,
                            new: this.password,
                        }
                    }
                }),
                credentials: 'same-origin',
            });

            if (res.errors) {
                // console.log(res.errors);
                return;
            }
            console.log('password updated');
            this.cancel();
        },
    },
};
</script>
